import { InputMask } from "@react-input/mask";
import Header from "@/atomic/atoms/Header";
import { PropsView } from "./Models";
import Button from "@/atomic/atoms/Button";
import Modal from "@/atomic/atoms/Modal";
import Loading from "@/atomic/atoms/Loading";

const inputBase =
  "w-full h-14 px-4 rounded-xl border font-primary text-base text-text bg-white placeholder:text-tertiary " +
  "focus:outline-none focus:ring-0 focus:border-primary";

const disabledClass =
  "disabled:bg-background disabled:text-tertiary disabled:cursor-not-allowed";

function fieldClass(extra?: string) {
  return [inputBase, "border-border", disabledClass, extra]
    .filter(Boolean)
    .join(" ");
}

export default function MyDataView({
  goBack,
  customer,
  onChange,
  submit,
  isDisabled,
  setZipcode,
  address,
  phone,
  email,
  setCity,
  setComplement,
  setNeighborhood,
  setNumber,
  setState,
  setStreetName,
  setEmail,
  setPhone,
  editable,
  success,
  error,
  setError,
  isLoading,
  setErrorZipcode,
  errorZipcode,
  setSuccess,
}: PropsView) {
  return (
    <div className="h-full relative flex flex-col bg-white overflow-hidden">
      <Header title="Meus dados" hasLeftButton goBack={goBack} />
      <main className="flex-1 w-full flex justify-center min-h-0 bg-background">
        <article className="w-full max-w-[480px] px-6 pt-6 pb-8 flex flex-col flex-1 min-h-0">
          <div className="flex-1 min-h-0 overflow-y-auto pb-4">
            <h2 className="text-text text-[22px] leading-tight font-primary font-semibold tracking-tight">
              Dados cadastrais
            </h2>
            <p className="text-tertiary text-sm font-primary mt-1">
              Altere os dados do seu acesso.
            </p>

            <div className="mt-6 flex flex-col gap-5">
              <div>
                <label className="block text-sm font-primary text-text mb-2">
                  CPF
                </label>
                <InputMask
                  name="document"
                  defaultValue={
                    customer?.client?.document?.replace(
                      /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
                      "$1.$2.$3-$4",
                    ) ?? ""
                  }
                  required
                  type="text"
                  inputMode="numeric"
                  mask="___.___.___-__"
                  replacement={{ _: /\d/ }}
                  disabled
                  placeholder="Seu CPF/CNPJ"
                  className={fieldClass()}
                />
              </div>

              <div>
                <label className="block text-sm font-primary text-text mb-2">
                  Nome completo
                </label>
                <input
                  defaultValue={customer?.client?.name ?? ""}
                  required
                  type="text"
                  name="name"
                  disabled
                  placeholder="Nome completo"
                  className={fieldClass()}
                />
              </div>

              <div>
                <label className="block text-sm font-primary text-text mb-2">
                  Celular
                </label>
                <InputMask
                  value={phone}
                  name="phone"
                  required
                  onChange={(event) => onChange(setPhone, event)}
                  type="text"
                  inputMode="numeric"
                  mask="(__) _____-____"
                  replacement={{ _: /\d/ }}
                  placeholder="Celular"
                  className={fieldClass()}
                />
              </div>

              <div>
                <label className="block text-sm font-primary text-text mb-2">
                  E-mail
                </label>
                <input
                  value={email}
                  required
                  onChange={(event) => onChange(setEmail, event)}
                  type="text"
                  inputMode="email"
                  name="email"
                  placeholder="E-mail"
                  className={fieldClass()}
                />
              </div>

              <div>
                <label className="block text-sm font-primary text-text mb-2">
                  CEP
                </label>
                <InputMask
                  value={address?.zipcode ?? ""}
                  name="zipcode"
                  required
                  onChange={(event) => onChange(setZipcode, event)}
                  type="text"
                  inputMode="numeric"
                  mask="_____-___"
                  replacement={{ _: /\d/ }}
                  placeholder="Seu CEP"
                  className={fieldClass()}
                />
              </div>

              <div className="flex flex-row gap-3 min-w-0">
                <div className="min-w-0 flex-[7]">
                  <label className="block text-sm font-primary text-text mb-2">
                    Logradouro
                  </label>
                  <input
                    value={address?.streetName ?? ""}
                    required
                    onChange={(event) => onChange(setStreetName, event)}
                    type="text"
                    name="streetName"
                    placeholder="Logradouro"
                    disabled={!editable}
                    className={fieldClass()}
                  />
                </div>
                <div className="min-w-0 flex-[3] max-w-[120px]">
                  <label className="block text-sm font-primary text-text mb-2">
                    Nº
                  </label>
                  <input
                    value={address?.number ?? ""}
                    required
                    onChange={(event) => onChange(setNumber, event)}
                    type="text"
                    name="number"
                    placeholder="Nº"
                    className={fieldClass()}
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-primary text-text mb-2">
                  Complemento
                </label>
                <input
                  value={address?.complement ?? ""}
                  required
                  onChange={(event) => onChange(setComplement, event)}
                  type="text"
                  name="complement"
                  placeholder="Complemento"
                  className={fieldClass()}
                />
              </div>

              <div>
                <label className="block text-sm font-primary text-text mb-2">
                  Bairro
                </label>
                <input
                  value={address?.neighborhood ?? ""}
                  required
                  onChange={(event) => onChange(setNeighborhood, event)}
                  type="text"
                  name="neighborhood"
                  placeholder="Bairro"
                  disabled={!editable}
                  className={fieldClass()}
                />
              </div>

              <div className="flex flex-row gap-3 min-w-0">
                <div className="min-w-0 flex-[13]">
                  <label className="block text-sm font-primary text-text mb-2">
                    Cidade
                  </label>
                  <input
                    value={address?.city ?? ""}
                    required
                    onChange={(event) => onChange(setCity, event)}
                    type="text"
                    name="city"
                    placeholder="Cidade"
                    disabled={!editable}
                    className={fieldClass()}
                  />
                </div>
                <div className="min-w-0 flex-[7] max-w-[100px]">
                  <label className="block text-sm font-primary text-text mb-2">
                    UF
                  </label>
                  <InputMask
                    value={address?.state ?? ""}
                    name="state"
                    required
                    onChange={(event) => onChange(setState, event)}
                    type="text"
                    mask="__"
                    replacement={{ _: /\D/ }}
                    placeholder="UF"
                    disabled={!editable}
                    className={fieldClass("uppercase")}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8 shrink-0">
            <Button
              className="rounded-theme-large bg-primary text-white font-primary font-semibold border-0"
              title="Atualizar"
              onClick={submit}
              type="submit"
              isDisabled={isDisabled}
            />
          </div>
        </article>
      </main>
      {success && (
        <Modal
          title="Tudo certo!"
          message="Seus dados foram atualizados com sucesso."
          actionMessage="Ok"
          action={() => setSuccess(false)}
        />
      )}
      {error && (
        <Modal
          title="Ops!"
          message="Não foi possível atualizar seus dados. Deseja tentar novamente?"
          actionMessage="Sim"
          action={submit}
          actionSecondMessage="Não"
          actionSecond={() => setError(false)}
        />
      )}
      {errorZipcode && (
        <Modal
          title="Atenção"
          message="Cep inválido"
          actionMessage="Usar outro cep"
          action={() => setErrorZipcode(false)}
        />
      )}
      {isLoading && <Loading />}
    </div>
  );
}
